import { ChangeEvent, forwardRef } from 'react';
import classNames from 'classnames';
import ErrorMessage from '../error-message/error-message';

export interface EETextAreaProps {
  className?: string;
  name?: string;
  value?: string;
  placeholder?: string;
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  errors?: any;
  touched?: boolean;
  previewOnly?: boolean;
}

export const EETextArea = forwardRef<HTMLTextAreaElement, EETextAreaProps>(
  function EETextArea(
    {
      className,
      name,
      value,
      placeholder,
      onChange,
      onBlur,
      errors,
      touched,
      previewOnly,
    },
    ref
  ) {
    return (
      <div>
        <textarea
          ref={ref}
          id={name}
          name={name}
          placeholder={placeholder}
          className={classNames(
            'rounded-md border-2 border-gray-400 p-2 text-custom-textColor w-full',
            className
          )}
          onChange={onChange}
          value={value}
          disabled={previewOnly}
        />
        <ErrorMessage errors={errors} touched={touched} />
      </div>
    );
  }
);

export default EETextArea;
